export const CREATIVE_DEFAULT_HEADERS = [
  {
    id: 'files',
    label: 'Media',
    type: 'image',
    sortable: false,
  },
  {
    id: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    id: 'duration',
    label: 'Duration',
    sortable: false,
  },
  {
    id: 'createdAt',
    label: 'Added On',
    type: 'timeInfo',
    sortable: true,
  },
  {
    id: 'updatedAt',
    label: 'Updated On',
    type: 'timeInfo',
    sortable: true,
  },
];

export const CREATIVE_LIBRARY_HEADERS = [
  {
    id: 'brandName',
    label: 'Brand Folder Name',
    sortable: false,
  },
  {
    id: 'creativeCount',
    label: 'Number of Creatives',
    sortable: false,
  },
  {
    id: 'createdAtInfo',
    label: 'Created By',
    sortable: false,
  },
  {
    id: 'updatedAtInfo',
    label: 'Last Updated By',
    sortable: false,
  },
];

export const CREATIVE_BRAND_FILE_HEADERS = [
  {
    id: 'files',
    label: 'Media',
    type: 'image',
    sortable: false,
  },
  {
    id: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    id: 'fileType',
    label: 'File Type',
    sortable: false,
  },
  {
    id: 'resolution',
    label: 'Resolution',
    sortable: false,
  },
  {
    id: 'aspectRatio',
    label: 'Aspect Ratio',
    sortable: false,
  },
  {
    id: 'createdAt',
    label: 'Added On',
    type: 'timeInfo',
    sortable: true,
  },
  {
    id: 'updatedAt',
    label: 'Updated On',
    type: 'timeInfo',
    sortable: true,
  },
];

export const CREATIVE_TYPE_OPTIONS = [
  { value: 'image', label: 'Image / Video' },
  { value: 'VAST', label: 'VAST Tag' },
  { value: 'WEB', label: 'Web URL' },
] as const;
